import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../lib/constants";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-navy text-white mt-16">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-3">
            <Logo size={40} tone="pill" />
            <div>
              <div className="font-bold">Melopa Invents</div>
              <div className="text-[10px] uppercase tracking-widest text-[var(--melopa-gold)]">Pvt Ltd</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Government Contracting, Institutional Supplies & Infrastructure Solutions partner based in Bengaluru.
          </p>
        </div>
        <div>
          <div className="font-semibold mb-3 text-sm uppercase tracking-wider text-white/80">Navigate</div>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.slice(0, 6).map((l) => (
              <li key={l.to}>
                <Link className="text-white/70 hover:text-white" to={l.to}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3 text-sm uppercase tracking-wider text-white/80">Engage</div>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.slice(6).map((l) => (
              <li key={l.to}>
                <Link className="text-white/70 hover:text-white" to={l.to}>{l.label}</Link>
              </li>
            ))}
            <li><Link className="text-white/70 hover:text-white" to="/admin">Admin</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3 text-sm uppercase tracking-wider text-white/80">Contact</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[var(--melopa-gold)]" /> {COMPANY.phone}</li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[var(--melopa-gold)]" /> {COMPANY.email}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[var(--melopa-gold)]" /> {COMPANY.address}</li>
          </ul>
          <div className="mt-4 grid grid-cols-2 gap-2 text-[11px] text-white/70">
            <div><span className="text-white/50">CIN:</span> {COMPANY.cin}</div>
            <div><span className="text-white/50">GSTIN:</span> {COMPANY.gstin}</div>
            <div><span className="text-white/50">MSME:</span> {COMPANY.msme}</div>
            <div><span className="text-white/50">FSSAI:</span> {COMPANY.fssai}</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Melopa Invents Pvt Ltd. All rights reserved.</div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Use</Link>
            <span>Bengaluru, Karnataka, India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
